import ApocalypseEventTarget from "rydori-apocalypse-commonjs/core/ApocalypseEventTarget";
import symbols from "configs/symbols";
// import { proxyUrl } from "configs/config";
import APIHelper from "@giscon/utils.api-helper-esri";
import layerStore, { Layer } from "@giscon/utils.layer-store";
import {
  addAndLoadFeatureLayer,
  createFeatureLayer,
  calculateRulePolygons,
} from "./utils/Layer";
import SelectionManager from "./SelectionManager";

export default class LayerManager extends ApocalypseEventTarget {
  static get availableEvents() {
    return ["layer-clicked"];
  }

  constructor({ controller, map, /* layers, */ view, selectionMode, nls }) {
    super();
    this.controller = controller;
    this.map = map;
    this.view = view;
    this.highlightLayer = APIHelper.createGraphicsLayer({
      id: "editorHighlightLayer",
    });
    APIHelper.addToMap(this.map, this.highlightLayer);
    APIHelper.setLayersMouseEventsDisabled(this.highlightLayer, true);

    this.graphicsLayer = APIHelper.createGraphicsLayer({
      id: "editorGraphicsLayer",
    });
    // this.resetAndSetLayers(layers);
    APIHelper.addToMap(this.map, this.graphicsLayer);
    this.symbols = symbols(APIHelper.version);
    this.disabledEvents = [];
    this.indices = {
      // pendant to editfeatures & rawFeatures, indexed by layer and id
      edit: {},
      raw: {},
    };
    this.disabledLayers = [];
    for (let i = 0; i < layerStore.layers.length; i++) {
      this.indices.edit[i] = {}; // TODO: indices
    }
    this.nextInternalID = 0;
    this.deleted = {};
    this.editors = [];
    this.registerClickHandler();
    this.selectionManager = new SelectionManager({
      layerManager: this,
      selectionMode,
      nls,
    });
  }

  registerEditor(editor) {
    this.editors.push(editor);
  }

  unregisterEditor(editor) {
    const i = this.editors.indexOf(editor);
    if (i !== -1) {
      this.editors.splice(i, 1);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  addLoadingPromise(promise) {
    return layerStore.addLoadingPromise(promise);
  }

  hasChanges() {
    return this.editors.reduce((acc, editor) => {
      return acc || editor.hasChanges();
    }, false);
  }

  getCurrentAction() {
    return this.editors.reduce((acc, editor) => {
      return acc || editor.currentAction;
    }, null);
  }

  applyRole(role) {
    const layersInfo = role && role.layer ? role.layer : [];
    let aborted = false;
    APIHelper.disablePanZoom(this.map, this.view);
    this.removeClickHandler();
    this.clearGraphicsLayer();
    this.disabledLayers = [];
    layerStore.layers // TODO: maybe einschränken mit nem filter, da nicht alles von Rolle abhängt?!?
      .concat([])
      .filter(
        (l) => l.layer !== this.highlightLayer && l.layer !== this.graphicsLayer
      )
      .forEach((layer) => {
        APIHelper.removeFromMap(this.map, layer.layer);
      });
    layerStore.setRoleLayers([]);
    this.previousEditRule = null;
    APIHelper.removeAllGraphics(this.highlightLayer);
    // create layers
    let i = 0;
    let layerpromises = layersInfo.map((layerInfo) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(createFeatureLayer(layerInfo, role.gisconToken));
        }, i++ * 200);
      });
    }); // on error it throws !!

    // create abort function  => abort running task
    const abort = () => {
      aborted = true;
      layerpromises.forEach((layer) =>
        layer.then((l) => APIHelper.removeFromMap(this.map, l))
      );
    };
    if (this.abortLoad) {
      const old = this.abortLoad;
      this.abortLoad = undefined;
      old();
      this.abortLoad = abort;
    } else {
      this.abortLoad = abort;
    }

    this.disabledLayers = /* disabledLayers || */[];
    this.indices = {
      // pendant to editfeatures & rawFeatures, indexed by layer and id
      edit: {},
      raw: {},
    };

    this.nextInternalID = 0;
    this.deleted = {};
    // this.registerClickHandler();

    return new Promise((resolve, reject) => {
      Promise.all(layerpromises)
        .then((layers) => {
          return Promise.all(
            // add layers to map and wait for loaded
            layers.forEach(
              (layer) => addAndLoadFeatureLayer(this.map, layer, true) // TODO: maybe das true raus, aber NUR bei NICHT EDITIERBAREN LAYERS
            )
          )
            .then((values) => {
              layers = values;
              return calculateRulePolygons(layers, this.map, this.symbols.mask);
            })
            .then(() => {
              // rule polygons calculated and saved in layerInfos
              this.previousEditRule = null;
              this.highlightEditRule(null);
              layers.forEach((layer) => APIHelper.setVisibility(layer)); // layer.setVisibility(layer.defaultVisibility)); // TODO in API Helper auslagern
              return layerStore.setRoleLayers(
                layers || [] // layer
                // this.map // map
                // layers.map((layer) => layer.layerInfo) || [], // permissions
                // permissions are now in layer (layer.layerIndo)
              );
            })
            .then(() => {
              if (!aborted) {
                this.indices.edit = [];
                for (let i = 0; i < layerStore.layers.length; i++) {
                  this.indices.edit[i] = {}; // TODO: indices
                }
                APIHelper.enablePanZoom(this.map, this.view);
                layers.forEach((layer) => {
                  APIHelper.putLayerOnTop(this.map, layer);
                });
                this.putGraphicsLayerOnTop();
                this.registerClickHandler();
                this.setPointerEvents(); // important bugfix!!!
                resolve(false);
              } else {
                resolve(true);
              }
            });
        })
        .catch((a, b) => {
          // eslint-disable-next-line no-console
          console.error("Failed To Load Layer ", a, b);
          // resolve(false);
          abort(); // TODO: is here something more important if this.abortLoad == abort wegen BI und so??
          reject(new Error("An Error Occurred", a, b));
        });
    });
  }

  clearGraphicsLayer() {
    APIHelper.removeAllGraphics(this.graphicsLayer);
  }

  reset() {
    const selection = this.selectionManager
      .getSelection()
      .map((g) => {
        return this.getRawFeatures(g);
      })
      .reduce((acc, val) => acc.concat(val), []) // flat;
      .sort()
      .filter(function (item, pos, ary) {
        // filter duplicates - https://stackoverflow.com/questions/9229645/remove-duplicate-values-from-js-array
        return !pos || item !== ary[pos - 1];
      });

    this.removeClickHandler();
    this.selectionManager.selection = [];
    this.clearGraphicsLayer();
    APIHelper.removeAllGraphics(this.highlightLayer);
    // this.disabledLayers = disabledLayers || []; // TODO: tocheck
    this.indices = {
      // pendant to editfeatures & rawFeatures, indexed by layer and id
      edit: {},
      raw: {},
    };

    this.nextInternalID = 0;
    this.deleted = {};

    for (let i = 0; i < layerStore.layers.length; i++) {
      this.indices.edit[i] = {}; // TODO: indices
    }

    APIHelper.getNonGeneralized(selection)
      .then((selectedNonGeneralized) => {
        const nonGSelection = selectedNonGeneralized.flat();
        this.selectionManager.select(nonGSelection, true);
      })
      .catch((e) => {
        console.error("Selectionerror: ", e);
      });
    this.registerClickHandler();
    this.putGraphicsLayerOnTop();
  }

  getAttributes(feature) {
    return APIHelper.getAttributes(APIHelper.getGraphic(feature));
  }

  addSelectionLayer(layer) {
    layerStore.addLayer(layer); // TODO
    this.indices.edit[layerStore.layers.length - 1] = {}; // add one more  // TODO: indices
    this.putGraphicsLayerOnTop();
  }

  zoomToGraphics(graphics) {
    const { map, view } = this;
    const extent = APIHelper.getSurroundingExtent(graphics);
    if (extent) APIHelper.zoomToExtent(map, extent, view, 1.2);
  }

  setPointerEvents(disableEvents) {
    const value = (
      disableEvents === undefined ? this.disabledEvents : disableEvents
    )
      ? "none"
      : "auto";
    this.disabledEvents = value;
    APIHelper.setPointerEventsOnMapLayersExept(
      this.map,
      value,
      layerStore.layers
        .map((l) => {
          return l.layer;
        })
        .concat([this.graphicsLayer]),
      "auto" // except value
    );
  }

  // TODO: API
  putGraphicsLayerOnTop() {
    APIHelper.putLayerOnTop(this.map, this.graphicsLayer);
    APIHelper.putLayerOnTop(this.map, this.highlightLayer);
  }

  setSelectionManager(sm) {
    this.selectionManager = sm;
  }

  getSelectionManager(sm) {
    return this.selectionManager;
  }

  removeClickHandler() {
    // console.error('remove click handler');
    if (this.clickHandler) this.clickHandler.remove();
    this.clickHandler = null;
  }

  disableLayers(layers) {
    this.fireEvent("layer-clicked", { hits: [] }); // to reset selection
    this.disabledLayers = Array.isArray(layers) ? layers : [];
    if (this.clickHandler) this.registerClickHandler();
  }

  disableAllBut(layer) {
    const layers = [];
    if (Array.isArray(layer)) {
      layer.forEach((l) => {
        layers.push(l);
      });
    } else if (layer) {
      layers.push(layer);
    }

    this.disabledLayers = layerStore.layers.filter((pLayer) => {
      return layers.indexOf(pLayer.layer) === -1;
    });
    if (this.clickHandler) this.registerClickHandler();
  }

  restoreDisabled() {
    this.disabledLayers = layerStore.layers
      .filter((layer) => {
        return !layer.selectable;
      })
      .map((layer) => {
        return layer.layer;
      });
    if (this.clickHandler) this.registerClickHandler();
  }

  toggleDisableLayer(layer) {
    if (this.disabledLayers.includes(layer)) {
      const index = this.disabledLayers.indexOf(layer);
      this.disabledLayers.splice(index, 1);
    } else {
      this.disabledLayers.push(layer);
    }
    if (this.clickHandler) this.registerClickHandler();
  }

  setLayerDisabled(layer, disabled) {
    if (this.disabledLayers.includes(layer) && !disabled) {
      const index = this.disabledLayers.indexOf(layer);
      this.disabledLayers.splice(index, 1);
    } else if (disabled) {
      this.disabledLayers.push(layer);
    }
    if (this.clickHandler) this.registerClickHandler();
  }

  registerClickHandler() {
    this.removeClickHandler();
    // console.error('register click handler');
    this.clickHandler = APIHelper.registerClickHandlerOnLayers(
      (success, hits, error) => {
        if (success) {
          const editHits = hits.filter((hit) => {
            return this.isEditGraphic(hit);
          });
          const nonEditHits = hits.filter((hit) => {
            let hasEditFeatureInSelection = false;
            if (editHits.indexOf(hit) !== -1) return false; // is an edit Hit
            const edits = this.getEditGraphics(hit, false);
            for (let i = 0; i < edits.length; i++) {
              if (editHits.indexOf(edits[i]) !== -1) {
                hasEditFeatureInSelection = true;
                break;
              }
            }
            return !hasEditFeatureInSelection; // has an edit hit in selection?
          });
          const filteredHits = nonEditHits.concat(editHits);

          this.fireEvent("layer-clicked", { hits: filteredHits });
          // eslint-disable-next-line no-console
          if (error) console.error(error); // TODO?
        } else {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      },
      [this.graphicsLayer]
        .concat(
          layerStore.layers.map((l) => {
            return l.layer;
          })
        )
        .filter((layer) => {
          // TODO: checken, dass in disabled layers auch wirklich deie layer stehen, sonst gibts nen problem
          return this.disabledLayers.indexOf(layer) === -1;
        }),
      this.map,
      this.view
    );
  }

  static isSameRawFeature(feat1, feat2) {
    const idField = APIHelper.getObjectIdField(APIHelper.getLayer(feat1));
    return (
      APIHelper.getAttributes(feat1)[idField] ===
      APIHelper.getAttributes(feat2)[idField]
    );
  }

  isSelected(graphic) {
    return this.selectionManager.isSelected(graphic);
  }

  isEditGraphic(feature) {
    // TODO:ESRI API DEPENDANT - sollte bei v3 nichts kaputt machen
    if (feature.graphic) return false;
    return APIHelper.getLayer(feature) === this.graphicsLayer;
  }

  /*
  static toGraphic(feature) {
    // TODO:ESRI API DEPENDANT - aber würde auch bei v3 nichts kaputt machen
    if (feature.graphic) return feature.graphic;
    return feature;
  }
*/

  static getGeometry(feature) {
    return APIHelper.getGeometry(APIHelper.getGraphic(feature));
  }

  // eslint-disable-next-line class-methods-use-this
  getGraphicsByAttributeAndValue(layerName, name, value) {
    // TODO: hier einfach direkt ne Query raushauen
    const layer = layerStore.getLayer(layerName);
    const graphics = [];
    const layerGraphics = APIHelper.getLayerGraphicsArray(layer);
    if (Array.isArray(layer)) {
      for (let i = 0; i < layerGraphics.length; i++) {
        const graphic = layerGraphics[i];
        const attributes = APIHelper.getAttributes(graphic);
        // eslint-disable-next-line eqeqeq
        if (attributes && value.indexOf(attributes[name]) !== -1) {
          // must be == because id is a string and in url its an number
          graphics.push(graphic);
        }
      }
    } else {
      for (let i = 0; i < layerGraphics.length; i++) {
        const graphic = layerGraphics[i];
        const attributes = APIHelper.getAttributes(graphic);
        // eslint-disable-next-line eqeqeq
        if (attributes && attributes[name] == value) {
          // must be == because id is a string and in url its an number
          graphics.push(graphic);
        }
      }
    }
    return graphics;
  }

  // eslint-disable-next-line class-methods-use-this
  getGraphicsByAttributeAndValueArray(layerGraphics, name, value) {
    // TODO: hier einfach direkt ne Query raushauen
    const graphics = [];
    for (let i = 0; i < layerGraphics.length; i++) {
      const graphic = layerGraphics[i];
      const attributes = APIHelper.getAttributes(graphic);
      // eslint-disable-next-line eqeqeq
      if (attributes && attributes[name] == value) {
        // must be == because id is a string and in url its an number
        graphics.push(graphic);
      }
    }
    return graphics;
  }

  static getGeometryType(featue) {
    return LayerManager.getGeometryType(featue);
  }

  getSymbol(geotype, state) {
    return this.symbols[geotype][state];
  }

  showEditRule(layer, setPrevious) {
    const { currentEditRule } = layerStore;
    let editRule = layer;
    if (layer instanceof Layer) {
      editRule = layer.editRule;
    } else if (APIHelper.isLayer(layer)) {
      const layerObj = layerStore.getLayer(layer);
      editRule = layerObj.editRule;
    }
    if (currentEditRule !== editRule) {
      if (currentEditRule) {
        this.resetEditRule();
      }
      if (setPrevious) {
        this.previousEditRule = editRule;
      }
      layerStore.currentEditRule = editRule;
      this.highlightEditRule(editRule ? editRule.highlightGraphic : null);
    }
  }

  resetEditRule(unsetPrevious) {
    if (unsetPrevious) {
      this.previousEditRule = null;
    }
    layerStore.currentEditRule = null;
    this.highlightEditRule(
      this.previousEditRule ? this.previousEditRule.highlightGraphic : null
    );
  }

  createEditGraphic(feature) {
    const temp = APIHelper.getGraphic(feature); // ESRI API DEPENDANT - siehe Funktion
    const geometry = APIHelper.cloneGeometry(APIHelper.getGeometry(temp)); // ESRI API DEPENDANT - weiß nicht ob clone in v3 verfpgbar ist
    const symbol = this.getSymbol(
      APIHelper.getGeometryType(geometry),
      "default"
    );
    const attributes = APIHelper.cloneAttributes(temp);

    const id = this.nextInternalID++;
    const graphic = APIHelper.createGraphic(geometry, symbol, attributes); // ESRI API DEPENDANT - aufruf fast gleich könnte so also auch in v3 laufen
    graphic.internalEditorID = id;
    const layer = APIHelper.getLayer(feature);
    const fields = APIHelper.getFields(layer);
    graphic.fields =
      // eslint-disable-next-line no-underscore-dangle
      fields && fields.slice(); // TODO APIHelper
    // eslint-disable-next-line no-underscore-dangle
    graphic.featureLayer = layer;
    if (graphic.featureLayer) {
      const { permissions } = layerStore.getLayer(layer);
      this.evaluatePermission(graphic, permissions);
    }
    return graphic;
  }

  // eslint-disable-next-line class-methods-use-this
  evaluatePermission(graphic, permissions) {
    let readonly = false;
    if (permissions.editRule) {
      readonly = !APIHelper.intersects(
        permissions.editRule.ruleGeometries,
        APIHelper.getGeometry(graphic)
      );
    }
    // eslint-disable-next-line no-param-reassign
    graphic.readonly = readonly;
  }

  getGraphicByInternalId(id) {
    const graphics = APIHelper.getLayerGraphicsArray(this.graphicsLayer);
    for (let i = 0; i < graphics.length; i++) {
      const graphic = graphics[i];
      if (graphic.internalEditorID === id) {
        return graphic;
      }
    }
    return null;
  }

  delete(pIds, del) {
    const ids = Array.isArray(pIds) ? pIds : [pIds];
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      this.deleted[id] = !!del;
      if (del) {
        this.selectionManager.deselect(this.getGraphicByInternalId(id));
      }
    }
    this.redraw();
    return ids;
  }

  deleteAndApply(pIds) {
    const deleteIds = Array.isArray(pIds) ? pIds : [pIds];
    const applies = {};
    deleteIds.forEach((internalID) => {
      const indices = this.indices.raw[internalID];
      // if this.delete is executed before this line => this.indices.raw[internalID] is empty
      indices.forEach(({ idField, layer, id }) => {
        if (applies[layer] && applies[layer].ids.indexOf(id) === -1) {
          applies[layer].ids.push(id);
          applies[layer].internalIds.push(internalID);
        } else {
          applies[layer] = {
            layer: layerStore.layers[layer], // TODO: indices - use unique for [layer]
            idField,
            internalIds: [internalID],
            ids: [id],
          };
        }
      });
    });

    const promises = [];
    const keys = Object.keys(applies);
    for (let i = 0; i < keys.length; i++) {
      const { idField, layer, ids, internalIds } = applies[keys[i]];
      promises.push(
        new Promise(
          function (pInternalIds, resolve, reject) {
            layer
              .applyEdits(
                undefined,
                undefined,
                ids.map((id) => {
                  const obj = { attributes: {} };
                  obj.attributes[idField] = id;
                  return obj;
                })
              )
              .then(
                (value) => {
                  layer.refresh();
                  this.delete(pInternalIds, true);
                  resolve(value);
                },
                (err) => {
                  reject(err);
                }
              );
          }.bind(this, internalIds)
        )
      );
    }
    return Promise.all(promises);
  }

  getRawFeatures(graphic) {
    if (this.isEditGraphic(graphic))
      if (this.indices.raw[graphic.internalEditorID])
        return this.indices.raw[graphic.internalEditorID]
          .filter((item) => !!item.feature) // because created graphics do not have a raw feature!!!
          .map((item) => {
            return item.feature;
          });
    return [];
  }

  // (!this.layerManager.hasRawFeature(this.selection[0]) ||this.layerManager.getRawFeatures(this.selection[0]).layer)
  // feature.layer !== this.getOriginLayer(this.selection[0]).layer) &&

  getOriginLayer(graphic) {
    let layer = null;
    if (!this.hasRawFeature(graphic)) {
      if (
        this.isEditGraphic(graphic) &&
        this.indices.raw[graphic.internalEditorID] &&
        this.indices.raw[graphic.internalEditorID].length > 0 &&
        // eslint-disable-next-line no-restricted-globals
        !isNaN(this.indices.raw[graphic.internalEditorID][0].layer) // make sure a layer index exists
      ) {
        return layerStore.layers[
          this.indices.raw[graphic.internalEditorID][0].layer
        ];
      }
      layer = APIHelper.getLayer(graphic);
      // eslint-disable-next-line no-else-return
    } else if (this.isEditGraphic(graphic)) {
      layer = APIHelper.getLayer(this.getRawFeatures(graphic)[0]);
    } else layer = APIHelper.getLayer(graphic);
    if (layer) {
      const wrapper = layerStore.getLayer(layer);
      if (wrapper) {
        return wrapper;
      } else {
        return new Layer(layer, layerStore.map, layerStore.view);
      }
    } else {
      return null;
    }
  }

  hasRawFeature(graphic) {
    if (this.isEditGraphic(graphic))
      if (
        this.indices.raw[graphic.internalEditorID] &&
        this.indices.raw[graphic.internalEditorID].filter(
          (item) => !!item.feature
        )[0] // because created graphics do not have a raw feature!!!
      )
        return true;
    return false;
  }

  getRawLayer(editorGraphic) {
    // NOTE: ONLY THE FIRST LAYER IN RAW INDICES IS CONSIDERED (BE CAREFUL WHEN MERGE FROM MULTIPLE DIFFERENT LAYER)
    const indices = this.indices.raw[editorGraphic.internalEditorID];
    return (
      indices && indices[0] && layerStore.layersArray[indices[0].layer].layer // TODO: reicht hier einfach ein layerstore objekt?
    );
  }

  getLayerFields(editorGraphic) {
    return APIHelper.getFields(this.getRawLayer(editorGraphic));
  }

  getEditGraphicsByIdFromLayer(id, rawlayer) {
    let graphics = [];
    let layer = -1;
    layerStore.layers.forEach((l, i) => {
      if (l.layer === rawlayer || l.layer === rawlayer.layer) layer = i;
    }); // TODO: indices
    if (layer !== -1) {
      if (this.indices.edit[layer][id]) {
        graphics = this.indices.edit[layer][id];
      } else {
        console.warn(
          "getEditGraphicsByIdFromLayer - did not find editGraphic for id",
          { id, layer: rawlayer }
        );
      }
    } else {
      console.warn(
        "getEditGraphicsByIdFromLayer - did not find layer in LayerStore"
      );
    }
    return graphics;
  }

  getEditGraphics(feature, create) {
    // TODO: check if features are relevant here or if everything is a graphic
    let graphics = [];
    let layer = -1;
    layerStore.layers.forEach((l, i) => {
      if (l.layer === APIHelper.getLayer(feature)) layer = i;
    }); // TODO: indices
    if (layer !== -1) {
      const { idField } = layerStore.layers[layer];
      const attributes = APIHelper.getAttributes(feature);
      if (this.indices.edit[layer][attributes[idField]]) {
        graphics = this.indices.edit[layer][attributes[idField]];
      } else if (create) {
        graphics = [this.createEditGraphic(feature)];
        this.indices.edit[layer][attributes[idField]] = graphics;
        this.indices.raw[graphics[0].internalEditorID] = [
          {
            feature,
            idField,
            attributes: APIHelper.cloneAttributes(feature),
            id: attributes[idField],
            layer,
            layerurl: layerStore.layers[layer].url,
          },
        ];
        graphics[0].fields = layerStore.layers[layer].fields; // HACK ?
        APIHelper.addGraphicToLayer(graphics[0], this.graphicsLayer); // ESRI API DEPENDANT - ist in beiden gleich
        // feature.visible = false; // TODO: check
        // ESRI API DEPENDANT - hier schauen wie wir das umsetzen + vielleicht einfach alle Grafiken hinzufügen und dann das Layer verstecken oder so
      }
    } else if (APIHelper.getLayer(feature) === this.graphicsLayer) {
      return [feature];
    } else {
      console.warn("bisher noch nicht verwendet");
      graphics = [this.createEditGraphic(feature)];
      this.indices.raw[graphics[0].internalEditorID] = [];
      APIHelper.addGraphicToLayer(graphics[0], this.graphicsLayer);
      // feature.visible = false; // TODO: check wie 2 if cases vorher
    }
    return graphics;
  }

  redraw() {
    // TODO: check if change order is better
    this.removeUnusedGraphics();
    this.updateSymbols();
    // TODO: Important refresh of FeatureLayers after closing the editor, just to be sure
  }

  removeUnusedGraphics() {
    // TODO - Wenn der EditToolbar nur Features/Graphics übergeben werden entweder hier nicht vom Layer löschen oder diese auf ein Graphics Layer hinzufügen und dann kann hier die gleiche Behandlung mit dem entsprechenden GraphicsLayer in layerStore.layersArray durchführen (ist wahrscheinlich einfacher)
    const graphics = APIHelper.getLayerGraphicsArray(this.graphicsLayer); // ESRI API DEPENDANT - bei v3 ist graphics direkt schon ein array also in dem falle einfach ne kopiue von dem Array nötig z.B. mit concat
    for (let i = 0; i < graphics.length; i++) {
      const graphic = graphics[i];
      if (
        /* alle änderungen, löschuzngen über isModified aus history und zusätzlich noch überprüfung ob die grafik hinzugefügt wurde ohne dass diese von einem FeatureLayer kommt, wenn ja diese auf dem GraphicsLayer lassen */
        !this.isSelected(graphic) &&
        !this.isModified(graphic)
      ) {
        APIHelper.removeGraphicFromLayer(graphic, this.graphicsLayer);

        const rawinfo = this.indices.raw[graphic.internalEditorID][0];
        if (rawinfo && rawinfo.layer !== undefined && rawinfo.layer !== -1) {
          delete this.indices.edit[rawinfo.layer][rawinfo.id];
        }
        delete this.indices.raw[graphic.internalEditorID];
      }
    }
  }

  isModified(graphic) {
    return this.editors.reduce((acc, current) => {
      return (
        acc ||
        current.isInHistory(graphic.internalEditorID) ||
        current.hasAttributiveChange(graphic.internalEditorID)
      ); // dont remove if graphic is in at least one editor history (can be in 1 at maximum)
    }, false);
    // return false; // this.controller.isInHistory(graphic.internalEditorID);
    // TODO: nicht anhand eines attributs sondern daran erkennen ob eine Aktion diese Grafik verwendet hat in der History!!!
    /* if (graphic.layer === this.graphicsLayer) return false;
    return !!graphic.edited; */
  }

  updateSymbols() {
    const graphics = APIHelper.getLayerGraphicsArray(this.graphicsLayer); // ESRI API DEPENDANT - bei v3 ist graphics direkt schon ein array also in dem falle einfach ne kopiue von dem Array nötig z.B. mit concat
    for (let i = 0; i < graphics.length; i++) {
      this.updateSymbol(graphics[i]);
    }
  }

  updateSymbol(graphic) {
    // Sollten wir features hinzufügen die auch so drauf bleiben, sollten sie im unveränderten Zustand ihr Symbol beibehalten?
    let state = "default";
    if (this.isDeleted(graphic)) {
      state = "deleted";
      if (this.isSelected(graphic)) this.selectionManager.deselect(graphic); // cause you cannot select a deleted graphic
    } else if (this.isSelected(graphic)) state = "selected";
    APIHelper.setSymbol(
      graphic,
      this.getSymbol(
        APIHelper.getGeometryType(APIHelper.getGeometry(graphic)),
        state
      )
    );
  }

  isDeleted(graphic) {
    return !!this.deleted[graphic.internalEditorID];
  }

  hideGraphics(ids) {
    for (let i = 0; i < ids.length; i++) {
      const graphic = this.getGraphicByInternalId(ids[i]);
      APIHelper.hideGraphic(graphic);
      this.selectionManager.deselect(graphic);
    }
  }

  showGraphics(ids) {
    for (let i = 0; i < ids.length; i++) {
      const graphic = this.getGraphicByInternalId(ids[i]);
      APIHelper.showGraphic(graphic);
    }
  }

  createGraphics(geometries, attributes, ids, layer) {
    // const multAttributes = Array.isArray(attributes);
    let ret = [];
    if (geometries.length === 1 && ids.length === 0) {
      // create
      ret.push(this.createGraphic(geometries[0], ids, attributes, layer));
    } else if (geometries.length > 1 && ids.length === 1) {
      // cut
      ret = this.replaceGraphic(ids[0], geometries, attributes);
    } else if (geometries.length === 1 && ids.length > 1) {
      // merge
      ret.push(this.createGraphic(geometries[0], ids, attributes));
    } else {
      // eslint-disable-next-line no-throw-literal
      throw "unexpected behavior";
    }
    return ret;
  }

  replaceGraphic(internalID, geometries, attributes) {
    // cut
    // first geometry is a change => replace in edits indices
    // other idea every one is new
    // others are to add at any place where it is replaced
    const graphics = [];
    const idField =
      this.indices.raw[internalID] &&
      this.indices.raw[internalID][0] &&
      this.indices.raw[internalID][0].idField;
    for (let i = 0; i < geometries.length; i++) {
      const id = this.nextInternalID++;
      const atts = APIHelper.cloneAttributes(attributes);
      if (i === 0) {
        // main graphic
        const graphic = APIHelper.createGraphic(geometries[i], null, atts);
        graphic.internalEditorID = id;
        graphics.push(graphic);
      } else {
        // other graphic
        if (idField) {
          delete atts[idField];
        }
        const graphic = APIHelper.createGraphic(geometries[i], null, atts);
        graphic.internalEditorID = id;
        graphics.push(graphic);
      }
      this.indices.raw[id] = this.indices.raw[internalID].concat([]);
    }
    const ids = graphics.map((graphic) => {
      this.updateSymbol(graphic);
      APIHelper.addGraphicToLayer(graphic, this.graphicsLayer);
      return graphic.internalEditorID;
    });

    this.replaceIdsInEditindexWithGraphics([internalID], graphics);

    // to undo filter all ids returned by this function and concat with [this.getGraphicByInternalId(internalID)]
    // TODO: check that the old graphic with internalID is still on layer and is just not displayed
    return ids;
  }

  /*
  TODO: functions that are just rearranging the indices for redo undo
  besides that createGraphic and reaplceGraphics has to be joined or a switch has to be implemented in GraphicsAction depending on 1:n or n:1 correlation.
  */
  // undoReplaceGraphics(internalID, geometry, attributes) {}

  // undoCreateGraphics(internalID, geometry, attributes) {}

  rearrangeIndices(ids, newIds, undo) {
    if (ids.length === 1 && newIds.length > 1) {
      // cut
      if (undo) {
        this.replaceIdsInEditindexWithGraphics(
          newIds,
          ids.map((id) => {
            return this.getGraphicByInternalId(id);
          })
        );
      } else {
        this.replaceIdsInEditindexWithGraphics(
          ids,
          newIds.map((id) => {
            return this.getGraphicByInternalId(id);
          })
        );
      }
    } else if (newIds.length === 1 && ids.length > 1) {
      // merge
      if (undo) {
        this.undoReplaceInEditIndex(
          this.getGraphicByInternalId(newIds[0]).affectedEdits,
          newIds[0]
        );
      } else {
        /* graphic.affectedEdits = */
        this.replaceInEditIndex(this.getGraphicByInternalId(newIds[0]), ids);
        // affected edits dont change => no update
      }
    }
    // return this.layerManager.rearrangeIndices(ids, newIds, undo);
  }

  replaceIdsInEditindexWithGraphics(ids, graphics) {
    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const layer in this.indices.edit) {
      const layerArray = this.indices.edit[layer];
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (const id in layerArray) {
        const graphicsArr = layerArray[id];
        layerArray[id] = graphicsArr
          .filter((g) => {
            return ids.indexOf(g.internalEditorID) === -1;
          })
          .concat(graphics);
      }
    }
  }

  undoReplaceInEditIndex(affected, id) {
    for (let i = 0; i < affected.length; i++) {
      const todo = affected[i];
      this.indices.edit[todo.layer][todo.id] = this.indices.edit[todo.layer][
        todo.id
      ]
        .filter((g) => {
          return g.internalEditorID !== id;
        })
        .concat([todo.graphic]);
    }
  }

  replaceInEditIndex(graphic, ids) {
    const affectedArr = [];
    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const layer in this.indices.edit) {
      const layerArray = this.indices.edit[layer];
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (const lid in layerArray) {
        let affected = false;
        const graphics = layerArray[lid];
        for (let i = graphics.length - 1; i >= 0; i--) {
          for (let j = 0; j < ids.length; j++) {
            const internalId = ids[j];
            if (graphics[i].internalEditorID === internalId) {
              affectedArr.push({ layer, id: lid, graphic: graphics[i] });
              if (affected) {
                // graphic is already added to array
                graphics.splice(i, 1);
              } else {
                graphics.splice(i, 1, graphic);
                affected = true;
              }
              break;
            }
          }
        }
      }
    }
    return affectedArr;
  }

  concatRawIndices(ids) {
    const raws = [];
    for (let i = 0; i < ids.length; i++) {
      const indices = this.indices.raw[ids[i]];
      // do not add duplicates
      for (let j = 0; j < indices.length; j++) {
        if (raws.indexOf(indices[j]) === -1) {
          raws.push(indices[j]);
        }
      }
      // raws = raws.concat();
    }
    return raws;
  }

  createGraphic(geometry, fromIds, attributes, layer) {
    // merge
    const id = this.nextInternalID++;
    const graphic = APIHelper.createGraphic(geometry, null, attributes);
    graphic.internalEditorID = id;

    /*
    this.indices.edit[layer][feature.attributes[idField]] = graphics;
        this.indices.raw[graphics[0].internalEditorID] = [
          {
            feature,
            idField,
            attributes: APIHelper.cloneAttributes(feature),
            id: feature.attributes[idField],
            layer,
          },
        ];
    */
    if (!fromIds || fromIds.length === 0) {
      // create
      // TODO: from now on layer can be -1 and id, idfield can be null!!!
      const layerObj = layerStore.getLayer(layer);

      this.indices.raw[graphic.internalEditorID] = [
        {
          feature: null,
          idField: layerObj ? layerObj.idField : null,
          attributes: {}, // TODO: attributes auch übergeben?
          id: null,
          layerObj,
          layer: layerObj // TODO: indices - use unique
            ? layerStore.layers
              .map((l, i) => {
                return { layer: l.layer, i };
              })
              .filter((l) => {
                return l.layer === layer;
              })[0].i
            : -1,
          layerurl: layerObj ? layerObj.url : null,
        },
      ];
    } else {
      // merge
      graphic.affectedEdits = this.replaceInEditIndex(graphic, fromIds); // affectedArr;

      // to undo just delete graphic from all affected layers and ids and add affectedArr
      this.indices.raw[id] = this.concatRawIndices(fromIds); // raws;
    }
    // for undo nothing is to be done

    // TODO indices.edit
    // TODO: Mappings anpassen
    /*
      Handling for adding new edit graphic
        graphics = [this.createEditGraphic(feature)];
        this.indices.edit[layer][feature.attributes[idField]] = graphics;
    */
    this.updateSymbol(graphic);
    APIHelper.addGraphicToLayer(graphic, this.graphicsLayer);
    return id;
  }

  highlightEditRule(graphic) {
    APIHelper.clearLayer(this.highlightLayer);
    if (graphic) APIHelper.addGraphicToLayer(graphic, this.highlightLayer);
  }

  highlightInverse = (features, fullPolygon) => {
    APIHelper.clearLayer(this.highlightLayer);
    if (!(features && features.length > 0)) {
      return;
    }

    const symbol = {
      color: [0, 0, 0, 64],
      outline: {
        color: [0, 0, 0, 255],
        width: 1,
        type: "esriSLS",
        style: "esriSLSSolid",
      },
      type: "esriSFS",
      style: "esriSFSSolid",
    };

    let highlightGeometry = fullPolygon;
    if (APIHelper.isExtent(highlightGeometry)) {
      highlightGeometry = APIHelper.createPolygonFromExtent(highlightGeometry);
    }
    features.forEach((feature) => {
      highlightGeometry = APIHelper.differenceOfGeometries(
        highlightGeometry,
        APIHelper.getGeometry(feature)
      );
    });

    const highlightGraphic = APIHelper.createGraphic(
      APIHelper.createPolygon(highlightGeometry), // feature.geometry,
      symbol
    );

    APIHelper.addGraphicToLayer(this.highlightLayer, highlightGraphic);
  };

  prepareSnapping(customSymbol) {
    const snapLayerIds = layerStore.layers
      .filter((l) => l.selectable && l.visibility)
      .map((l) => l.id);
    /* const notToSnapIds = this.map.graphicsLayerIds.filter(
        (id) => snapLayerIds.indexOf(id) === -1,
      ); */
    const layerInfos = snapLayerIds.map((id) => {
      // TODO: testen ob einfach layerObj.layer möglich ist => oben einfach das .map weglassen oder auf .layer mappen
      const layer = this.map.getLayer(id);
      return {
        layer,
        snapToEdge: true,
        snapToPoint: true,
        snapToVertex: true,
      };
    });
    const manager = APIHelper.prepareSnapping(
      this.map,
      customSymbol,
      20,
      false,
      layerInfos
    );
    this.snappingManager = manager;
  }

  cleanupSnapping() {
    if (this.snappingManager) {
      APIHelper.cleanUpSnapping(this.map, this.snappingManager);
    }
  }

  activateSnapping() {
    if (this.snappingManager) {
      APIHelper.enableSnapping(this.map, this.snappingManager);
    }
  }

  deactivateSnapping() {
    if (this.snappingManager) {
      APIHelper.disableSnapping(this.map);
    }
  }

  zoomToFullExtent(layer) {
    const { map, view } = this;
    const extent = APIHelper.getLayersFullExtent(layer); //layer.fullExtent;
    if (extent) APIHelper.zoomToExtent(map, extent, view);
  }
}

export const getLayer = (feature) => {
  // getLayer of Feature or Graphic
  let layer = null;
  if (feature.graphic) {
    // TODO:ESRI API DEPENDANT - bei v3 sind features graphics, bei v4 gibt es feature.graphic
    layer = APIHelper.getLayer(feature.graphic);
  } else {
    layer = APIHelper.getLayer(feature);
  }
  return layer;
};

/*
  dupkicate edit graphics after cut and click on raw graphic...
*/
